








































import { Component, Vue, Prop } from "vue-property-decorator";
import { Plan, PlanSchedule } from "@foxone/api/src/models/hfox";
import ScheduleItem from "./ScheduleItem.vue";

@Component({
  components: {
    ScheduleItem
  }
})
class ScheduleList extends Vue {
  @Prop() plan!: Plan;

  schedules: PlanSchedule[] = [];

  loading = false;

  hasNext = true;

  get meta() {
    return {
      firstTime: this.$common.utils.date.formatDate(
        this.plan.created_at * 1000
      ),
      noRecords: this.schedules.length === 0,
      active: this.plan.status === "ACTIVE"
    };
  }

  get disabled() {
    return this.loading || !this.hasNext;
  }

  async loadData() {
    this.loading = true;
    await this.requestPlanSchedules();
    this.loading = false;
  }

  async requestPlanSchedules() {
    let query: any = { limit: 10 };
    const last = this.schedules[this.schedules.length - 1];
    query = { ...query, from_number: last && last.number };
    const schedules = await this.$api.hfox.getPlanSchedules(
      this.plan.id + "",
      query
    );
    this.schedules = [...this.schedules, ...schedules];
    if (schedules.length === 0) {
      this.hasNext = false;
    }
  }

  handleImport() {
    this.$helper.toFusionPath(this, "hfox", {
      name: "plan-id-schedules",
      params: { id: this.plan.id + "" }
    });
  }
}
export default ScheduleList;
